















































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { RequestService } from "@/services";
import Header from "@/components/Header.vue";
import {propertyTypes} from "@/services/properties";
import properties from "@/services/properties/vita-protezione";
import data, { selectChoices } from "@/services/data/vita-protezione";
import categories from "@/services/categories";
import { PnetDatePicker } from "@previnet/vue-datepicker";
import { it } from "vuejs-datepicker/dist/locale";
import { isNil } from "ramda";
import { format } from "date-fns";
import TextField from "@/components/TextField.vue";
import TextArea from "@/components/TextArea.vue";
import ComboBox from "@/components/ComboBox.vue";
import DatePicker from "@/components/DatePicker.vue";
import MultiComboBox from "@/components/MultiComboBox.vue";
import Frazionamento from "@/components/Frazionamento.vue";
import StringList from "@/components/StringList.vue";
import TextFieldSign from "@/components/TextFieldSign.vue";

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['productId', 'user'],
  components: {
    Header,
    TextField,
    ComboBox,
    DatePicker,
    MultiComboBox,
    Frazionamento,
    StringList,
    TextFieldSign,
    TextArea,
  },
  data: function() {
    return {
      loggedUser: this.$props.user,
      errorMsg: null as any,
      okMsg: null as any,
      modalErrorMsg: null as any,
      modalErrorTitle: null as any,
      ...properties,
      ...data,
      selectChoices,
      propertyTypes,
      it,
      ND: "n.d.",
      productIdSelected: this.$props.productId,
      propList: [],
      esitoRegistrazione: null as any,
      categories,
      premioMinimoField: {
        value: "",
        valueSign: "€",
      },
      etaMaxSottoscrizioneField: {
        value: "",
        valueSign: "anni",
      },
      etaMaxScadenzaField: {
        value: "",
        valueSign: "anni",
      },
      massiveFile: undefined,
      massiveLoaded: false,
      massiveResult: null as any,
    };
  },
  methods: {
    isNil,
    scrollTo(refName: string) {
      var element = this.$refs[refName] as any;
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
    formatDate: function(data: Date | string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, "dd/MM/yyyy");
    },
    dateFromString: function(value: string | Date) {
      if (typeof value !== "string" || isNil(value)) {
        return null;
      }

      const parts = value.split("/");
      if (parts.length == 3) {
        const dt = parts[1] + "/" + parts[0] + "/" + parts[2];

        const timestamp = Date.parse(dt);
        if (isNaN(timestamp) == false) {
          return new Date(timestamp);
        }
      }

      return null;
    },
    home: function() {
      const vm = this as any;
      vm.$router.push({ name: 'home-prodotti', params: {user: vm.loggedUser}});
    },
    back: function() {
      const vm = this as any;
      vm.$router.go(-1);
    },
    openModalConfirm: function() {
      const vm = this as any;
      if (vm.checkFields() == true) {
        vm.valorizzaTendine();
        vm.preparePropList();

        if (vm.errorMsg == null && vm.propList.length > 0) {
          vm.$bvModal.show("modal-confirm");
        }
      }
    },
    closeModalConfirm() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm");
    },
    openModalMassivo: function() {
      const vm = this as any;
      vm.massiveFile = undefined;
      vm.massiveLoaded = false;
      vm.massiveResult = null;
      vm.$bvModal.show("modal-massive");
    },
    closeModalMassivo() {
      const vm = this as any;
      vm.$bvModal.hide("modal-massive");
    },
    openModalError(msg: any, title: any) {
      const vm = this as any;
      if (msg === undefined) {
        vm.modalErrorMsg = "Non è stato possibile salvare i dati.";
      } else {
        vm.modalErrorMsg = msg;
      }
      if (title === undefined) {
        vm.modalErrorTitle = "ERRORE";
      } else {
        vm.modalErrorTitle = title;
      }
      vm.$bvModal.show("modal-error");
    },
    closeModalError() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error");
    },
    openModalConfirmOutcome() {
      const vm = this as any;
      vm.$bvModal.show("modal-confirm-outcome");
    },
    closeModalConfirmOutcome() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm-outcome");
    },
    onClickReturnConfirmOutcome() {
      const vm = this as any;
      vm.closeModalConfirmOutcome();
    },
    onClickReturnError() {
      const vm = this as any;
      vm.closeModalError();
    },
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
    multivaluesContain(multivalues: any, values: any) {
      if (multivalues != null && values != null) {
        return multivalues.filter(function(e: any) {
          return values.indexOf(e.code) >= 0;
        }).length > 0;
      }

      return false;
    },
    checkFields() {
      const vm = this as any;

      let numErr = 0;

      vm.errorMsg = null;
      vm.okMsg = null;
      if (
        properties.prodottoProperty.value == undefined ||
        properties.prodottoProperty.value == null ||
        properties.prodottoProperty.value == ""
      ) {
        vm.errorMsg =
          "Il campo " + properties.prodottoProperty.name + " deve essere valorizzato";
        numErr++;
      }

      let retValue = true;
      if (numErr > 0) {
        retValue = false;
      } else {
        vm.okMsg = "Prodotto " + properties.prodottoProperty.value + " registrato";
      }

      return retValue;
    },
    countFrazionamento(prop: any) {
      const vm = this as any;
      let count = 0;

      if (prop !== undefined && prop.frazionamento !== undefined) {
        const f = prop.frazionamento;
        if (f.mensile !== vm.ND) count++;
        if (f.bimestrale !== vm.ND) count++;
        if (f.trimestrale !== vm.ND) count++;
        if (f.quadrimestrale !== vm.ND) count++;
        if (f.semestrale !== vm.ND) count++;
      }

      return count;
    },
    isInteressiFrazionamentoND() {
      const vm = this as any;
      const isPremioAnnuo = selectChoices.tipoPremio.code == "22.1";
      const isNoFraz = vm.multivaluesContain(selectChoices.frazPremio, ["24.6"]);

      return !isPremioAnnuo || isNoFraz;
    },
    isFrazionamentoMensile() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["24.1"]);
    },
    isFrazionamentoBimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["24.2"]);
    },
    isFrazionamentoTrimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["24.3"]);
    },
    isFrazionamentoQuadrimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["24.4"]);
    },
    isFrazionamentoSemestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["24.5"]);
    },
    changeTariffe() {
      const vm = this as any;

      if (selectChoices.tariffe.code == '2.2a') {
        properties.codProdCollegatoProperty.value = vm.ND;
      } else {
        properties.codProdCollegatoProperty.value = "";
      }
    },
    changeFineComm() {
      const vm = this as any;
      properties.fineCommProperty.value = "";
      properties.fineCommProperty.dateValue = null;

      if (selectChoices.prodCommercio.code == "7.1") {
        properties.fineCommProperty.value = vm.ND;
      }
    },
    changeTipoPrestazione() {
      const vm = this as any;
      properties.tipoCapitaleProperty.value = "";
      properties.tipoRenditaProperty.value = "";

      if (!vm.multivaluesContain(selectChoices.tipoPrestazione, ["15.1"])) {
        selectChoices.tipoCapitale.code = "";
        selectChoices.tipoCapitale.description = "";
        properties.tipoCapitaleProperty.value = vm.ND;

        properties.capitaleAssicurabileProperty.value = vm.ND;
      } else {
        if (properties.capitaleAssicurabileProperty.value == vm.ND) {
          properties.capitaleAssicurabileProperty.value = "";
        }
      }

      if (!vm.multivaluesContain(selectChoices.tipoPrestazione, ["15.2"])) {
        selectChoices.tipoRendita.code = "";
        selectChoices.tipoRendita.description = "";
        properties.tipoRenditaProperty.value = vm.ND;

        properties.renditaAssicurabileProperty.value = vm.ND;
      } else {
        if (properties.renditaAssicurabileProperty.value == vm.ND) {
          properties.renditaAssicurabileProperty.value = "";
        }
      }
    },
    changeTipoPremio() {
      const vm = this as any;
      properties.frazPremioProperty.value = "";
      properties.durataPianoPagamentiProperty.value = "";
      properties.sospensionePremiProperty.value = "";
      properties.riattivazionePremiProperty.value = "";
      properties.riduzionePrestProperty.value = "";
      properties.interessiFrazProperty.value = "";

      if (selectChoices.tipoPremio.code != "22.1") {
        selectChoices.frazPremio = [];
        properties.frazPremioProperty.value = vm.ND;
        properties.frazPremioProperty.values = [];

        properties.interessiFrazProperty.value = vm.ND;
        properties.interessiFrazProperty.frazionamento = {
          mensile: "", mensileSign: "",
          bimestrale: "", bimestraleSign: "",
          trimestrale: "", trimestraleSign: "",
          quadrimestrale: "", quadrimestraleSign: "",
          semestrale: "", semestraleSign: "",
        };
      }

      if (selectChoices.tipoPremio.code == "22.3") {
        selectChoices.durataPianoPagamenti.code = "";
        selectChoices.durataPianoPagamenti.description = "";
        properties.durataPianoPagamentiProperty.value = vm.ND;
        properties.sospensionePremiProperty.value = vm.ND;
        properties.riattivazionePremiProperty.value = vm.ND;
        properties.riduzionePrestProperty.value = vm.ND;
      }
    },
    changeGeneric() {
      const vm = this as any;

      if (selectChoices.applSpeseEmissione.code != "58.1") {
        properties.speseEmissioneProperty.value = "Non applicate";
        properties.speseEmissioneProperty.stringList = [];
      } else if (properties.speseEmissioneProperty.value == "Non applicate") {
        properties.speseEmissioneProperty.value = "";
        properties.speseEmissioneProperty.stringList = [{ value: "", valueSign: "€", valueLabel: "Min." }, { value: "", valueSign: "€", valueLabel: "Max." }];
      }

      if (selectChoices.applCaricamentoPremio.code != "60.1") {
        properties.caricamentoPremioProperty.value = "Non applicato";
        properties.caricamentoPremioProperty.stringList = [];
      } else if (properties.caricamentoPremioProperty.value == "Non applicato") {
        properties.caricamentoPremioProperty.value = "";
        properties.caricamentoPremioProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];
      }

      if (selectChoices.applCaricamentoCapitale.code != "62.1") {
        properties.caricamentoCapitaleProperty.value = "Non applicato";
        properties.caricamentoCapitaleProperty.stringList = [];
      } else if (properties.caricamentoCapitaleProperty.value == "Non applicato") {
        properties.caricamentoCapitaleProperty.value = "";
        properties.caricamentoCapitaleProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];
      }

      if (selectChoices.applCaricamentoEuro.code != "64.1") {
        properties.caricamentoEuroProperty.value = "Non applicato";
        properties.caricamentoEuroProperty.stringList = [];
      } else if (properties.caricamentoEuroProperty.value == "Non applicato") {
        properties.caricamentoEuroProperty.value = "";
        properties.caricamentoEuroProperty.stringList = [{ value: "", valueSign: "€", valueLabel: "Min." }, { value: "", valueSign: "€", valueLabel: "Max." }];
      }

      if (selectChoices.presenzaCashback.code != "70.1") {
        properties.cashbackProperty.value = "Non riconosciuto";
        properties.cashbackProperty.stringList = [];
      } else if (properties.cashbackProperty.value == "Non riconosciuto") {
        properties.cashbackProperty.value = "";
        properties.cashbackProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];
      }

      if (selectChoices.tipoRetrDistr.code == "72.3") {
        properties.retrDistrProperty.value = "Non indicata";
        properties.retrDistrProperty.stringList = [];
      } else if (selectChoices.tipoRetrDistr.code == "72.4") {
        properties.retrDistrProperty.value = "Non prevista";
        properties.retrDistrProperty.stringList = [];
      } else if (properties.retrDistrProperty.value == "Non indicata" || properties.retrDistrProperty.value == "Non prevista") {
        properties.retrDistrProperty.value = "";
        properties.retrDistrProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];
      }
    },
    changeGaranzie() {
      const vm = this as any;

      if (!vm.multivaluesContain(selectChoices.garanzie, ['14.1']) && !vm.multivaluesContain(selectChoices.garanzieCompl, ['21.1'])) {
        properties.decessoQualsiasiProperty.value = vm.ND;
      } else if (properties.decessoQualsiasiProperty.value == vm.ND) {
        properties.decessoQualsiasiProperty.value = "";
      }

      if (!vm.multivaluesContain(selectChoices.garanzie, ['14.2']) && !vm.multivaluesContain(selectChoices.garanzieCompl, ['21.2'])) {
        properties.decessoInfortunioProperty.value = vm.ND;
      } else if (properties.decessoInfortunioProperty.value == vm.ND) {
        properties.decessoInfortunioProperty.value = "";
      }

      if (!vm.multivaluesContain(selectChoices.garanzie, ['14.3']) && !vm.multivaluesContain(selectChoices.garanzieCompl, ['21.3'])) {
        properties.decessoIncidenteProperty.value = vm.ND;
      } else if (properties.decessoIncidenteProperty.value == vm.ND) {
        properties.decessoIncidenteProperty.value = "";
      }

      if (!vm.multivaluesContain(selectChoices.garanzie, ['14.4']) && !vm.multivaluesContain(selectChoices.garanzieCompl, ['21.4'])) {
        properties.decessoMalattiaProperty.value = vm.ND;
      } else if (properties.decessoMalattiaProperty.value == vm.ND) {
        properties.decessoMalattiaProperty.value = "";
      }

      if (!vm.multivaluesContain(selectChoices.garanzie, ['14.5']) && !vm.multivaluesContain(selectChoices.garanzieCompl, ['21.5'])) {
        properties.decessoNucleoProperty.value = vm.ND;
      } else if (properties.decessoNucleoProperty.value == vm.ND) {
        properties.decessoNucleoProperty.value = "";
      }

      if (!vm.multivaluesContain(selectChoices.garanzie, ['14.6']) && !vm.multivaluesContain(selectChoices.garanzieCompl, ['21.6'])) {
        properties.nonAutosufficienzaProperty.value = vm.ND;
      } else if (properties.nonAutosufficienzaProperty.value == vm.ND) {
        properties.nonAutosufficienzaProperty.value = "";
      }

      if (!vm.multivaluesContain(selectChoices.garanzie, ['14.7']) && !vm.multivaluesContain(selectChoices.garanzieCompl, ['21.7'])) {
        properties.malattieProperty.value = vm.ND;
      } else if (properties.malattieProperty.value == vm.ND) {
        properties.malattieProperty.value = "";
      }

      if (!vm.multivaluesContain(selectChoices.garanzie, ['14.8']) && !vm.multivaluesContain(selectChoices.garanzieCompl, ['21.8'])) {
        properties.invInaProperty.value = vm.ND;
      } else if (properties.invInaProperty.value == vm.ND) {
        properties.invInaProperty.value = "";
      }

      if (!vm.multivaluesContain(selectChoices.garanzie, ['14.9']) && !vm.multivaluesContain(selectChoices.garanzieCompl, ['21.9'])) {
        properties.terminalProperty.value = vm.ND;
      } else if (properties.terminalProperty.value == vm.ND) {
        properties.terminalProperty.value = "";
      }

      if (!vm.multivaluesContain(selectChoices.garanzieCompl, ['21.10'])) {
        properties.altreGaranzieProperty.value = vm.ND;
      } else if (properties.altreGaranzieProperty.value == vm.ND) {
        properties.altreGaranzieProperty.value = "";
      }
    },
    isEmptyOrSpaces(str: string) {
      return str === null || str.match(/^ *$/) !== null;
    },
    //
    valorizzaTendine() {
      const vm = this as any;

      properties.tariffeProperty.code = selectChoices.tariffe.code;
      properties.tariffeProperty.value = selectChoices.tariffe.description;
      properties.compagniaProperty.code = selectChoices.compagnia.code;
      properties.compagniaProperty.value = selectChoices.compagnia.description;
      properties.mercatoProperty.values = selectChoices.mercato;
      properties.canaleProperty.values = selectChoices.canale;
      properties.prodCommercioProperty.code = selectChoices.prodCommercio.code;
      properties.prodCommercioProperty.value = selectChoices.prodCommercio.description;
      properties.tipoAssicurazioneProperty.code = selectChoices.tipoAssicurazione.code;
      properties.tipoAssicurazioneProperty.value = selectChoices.tipoAssicurazione.description;
      properties.tipoProdottoProperty.code = selectChoices.tipoProdotto.code;
      properties.tipoProdottoProperty.value = selectChoices.tipoProdotto.description;
      properties.garanzieProperty.values = selectChoices.garanzie;
      properties.tipoPrestazioneProperty.values = selectChoices.tipoPrestazione;
      if (properties.tipoCapitaleProperty.value !== vm.ND) {
        properties.tipoCapitaleProperty.code = selectChoices.tipoCapitale.code;
        properties.tipoCapitaleProperty.value = selectChoices.tipoCapitale.description;
      }
      if (properties.tipoRenditaProperty.value !== vm.ND) {
        properties.tipoRenditaProperty.code = selectChoices.tipoRendita.code;
        properties.tipoRenditaProperty.value = selectChoices.tipoRendita.description;
      }
      properties.garanzieComplProperty.values = selectChoices.garanzieCompl;
      properties.tipoPremioProperty.code = selectChoices.tipoPremio.code;
      properties.tipoPremioProperty.value = selectChoices.tipoPremio.description;
      properties.frazPremioProperty.values = selectChoices.frazPremio;
      if (properties.durataPianoPagamentiProperty.value !== vm.ND) {
        properties.durataPianoPagamentiProperty.code = selectChoices.durataPianoPagamenti.code;
        properties.durataPianoPagamentiProperty.value = selectChoices.durataPianoPagamenti.description;
      }
      properties.applSpeseEmissioneProperty.code = selectChoices.applSpeseEmissione.code;
      properties.applSpeseEmissioneProperty.value = selectChoices.applSpeseEmissione.description;
      properties.applCaricamentoPremioProperty.code = selectChoices.applCaricamentoPremio.code;
      properties.applCaricamentoPremioProperty.value = selectChoices.applCaricamentoPremio.description;
      properties.applCaricamentoCapitaleProperty.code = selectChoices.applCaricamentoCapitale.code;
      properties.applCaricamentoCapitaleProperty.value = selectChoices.applCaricamentoCapitale.description;
      properties.applCaricamentoEuroProperty.code = selectChoices.applCaricamentoEuro.code;
      properties.applCaricamentoEuroProperty.value = selectChoices.applCaricamentoEuro.description;
      properties.costoVisitaMedicaProperty.code = selectChoices.costoVisitaMedica.code;
      properties.costoVisitaMedicaProperty.value = selectChoices.costoVisitaMedica.description;
      properties.presenzaCashbackProperty.code = selectChoices.presenzaCashback.code;
      properties.presenzaCashbackProperty.value = selectChoices.presenzaCashback.description;
      properties.tipoRetrDistrProperty.code = selectChoices.tipoRetrDistr.code;
      properties.tipoRetrDistrProperty.value = selectChoices.tipoRetrDistr.description;
    },
    cleanAllProperties() {
      const vm = this as any;
      properties.prodottoProperty.value = "";
      properties.codProdCollegatoProperty.value = "";
      properties.distributoriProperty.value = ""; properties.distributoriProperty.stringList = [{ value: "", valueSign: "", valueLabel: "" }];
      properties.inizioCommProperty.value = ""; properties.inizioCommProperty.dateValue = null;
      properties.fineCommProperty.value = ""; properties.fineCommProperty.dateValue = null;
      properties.fineCommProperty.value = "";
      properties.edizioneDIPAggProperty.value = ""; properties.edizioneDIPAggProperty.dateValue = null;
      properties.descProdottoProperty.value = "";
      properties.tipoCapitaleProperty.value = "";
      properties.capitaleAssicurabileProperty.value = "";
      properties.tipoRenditaProperty.value = "";
      properties.renditaAssicurabileProperty.value = "";
      properties.premioMinimoProperty.value = "";
      vm.premioMinimoField.value = ""; vm.premioMinimoField.valueSign = "€";
      properties.frazPremioProperty.value = "";
      properties.durataContrattoProperty.value = "";
      properties.durataPianoPagamentiProperty.value = "";
      properties.etaMaxSottoscrizioneProperty.value = "";
      vm.etaMaxSottoscrizioneField.value = ""; vm.etaMaxSottoscrizioneField.valueSign = "anni";
      properties.etaMaxScadenzaProperty.value = "";
      vm.etaMaxScadenzaField.value = ""; vm.etaMaxScadenzaField.valueSign = "anni";
      properties.visitaMedicaProperty.value = "";
      properties.carenzaProperty.value = "";
      properties.targetMarketProperty.value = "";
      properties.decessoQualsiasiProperty.value = "";
      properties.decessoInfortunioProperty.value = "";
      properties.decessoIncidenteProperty.value = "";
      properties.decessoMalattiaProperty.value = "";
      properties.decessoNucleoProperty.value = "";
      properties.nonAutosufficienzaProperty.value = "";
      properties.malattieProperty.value = "";
      properties.invInaProperty.value = "";
      properties.terminalProperty.value = "";
      properties.altreGaranzieProperty.value = "";
      properties.altreOpzioniProperty.value = "";
      properties.sospensionePremiProperty.value = "";
      properties.riattivazionePremiProperty.value = "";
      properties.riduzionePrestProperty.value = "";
      properties.speseEmissioneProperty.value = ""; properties.speseEmissioneProperty.stringList = [{ value: "", valueSign: "€", valueLabel: "Min." }, { value: "", valueSign: "€", valueLabel: "Max." }];
      properties.caricamentoPremioProperty.value = ""; properties.caricamentoPremioProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];
      properties.caricamentoCapitaleProperty.value = ""; properties.caricamentoCapitaleProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];
      properties.caricamentoEuroProperty.value = ""; properties.caricamentoEuroProperty.stringList = [{ value: "", valueSign: "€", valueLabel: "Min." }, { value: "", valueSign: "€", valueLabel: "Max." }];
      properties.interessiFrazProperty.value = "";
      properties.altriCostiProperty.value = "";
      properties.cashbackProperty.value = ""; properties.cashbackProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];
      properties.retrDistrProperty.value = ""; properties.retrDistrProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." }, { value: "", valueSign: "%", valueLabel: "Max." }];

      properties.interessiFrazProperty.value = "";
      properties.interessiFrazProperty.frazionamento = {
        mensile: "", mensileSign: "",
        bimestrale: "", bimestraleSign: "",
        trimestrale: "", trimestraleSign: "",
        quadrimestrale: "", quadrimestraleSign: "",
        semestrale: "", semestraleSign: "",
      };

      properties.tariffeProperty.code = ""; properties.tariffeProperty.value = "";
      properties.compagniaProperty.code = ""; properties.compagniaProperty.value = "";
      properties.mercatoProperty.values = [];
      properties.canaleProperty.values = [];
      properties.prodCommercioProperty.code = ""; properties.prodCommercioProperty.value = "";
      properties.tipoAssicurazioneProperty.code = ""; properties.tipoAssicurazioneProperty.value = "";
      properties.tipoProdottoProperty.code = ""; properties.tipoProdottoProperty.value = "";
      properties.garanzieProperty.values = [];
      properties.tipoPrestazioneProperty.values = [];
      properties.tipoCapitaleProperty.code = ""; properties.tipoCapitaleProperty.value = "";
      properties.tipoRenditaProperty.code = ""; properties.tipoRenditaProperty.value = "";
      properties.garanzieComplProperty.values = [];
      properties.tipoPremioProperty.code = ""; properties.tipoPremioProperty.value = "";
      properties.frazPremioProperty.values = [];
      properties.durataPianoPagamentiProperty.code = ""; properties.durataPianoPagamentiProperty.value = "";
      properties.applSpeseEmissioneProperty.code = ""; properties.applSpeseEmissioneProperty.value = "";
      properties.applCaricamentoPremioProperty.code = ""; properties.applCaricamentoPremioProperty.value = "";
      properties.applCaricamentoCapitaleProperty.code = ""; properties.applCaricamentoCapitaleProperty.value = "";
      properties.applCaricamentoEuroProperty.code = ""; properties.applCaricamentoEuroProperty.value = "";
      properties.costoVisitaMedicaProperty.code = ""; properties.costoVisitaMedicaProperty.value = "";
      properties.presenzaCashbackProperty.code = ""; properties.presenzaCashbackProperty.value = "";
      properties.tipoRetrDistrProperty.code = ""; properties.tipoRetrDistrProperty.value = "";

      selectChoices.tariffe = { code: "", description: "" };
      selectChoices.compagnia = { code: "", description: "" };
      selectChoices.mercato = [];
      selectChoices.canale = [];
      selectChoices.prodCommercio = { code: "", description: "" };
      selectChoices.tipoAssicurazione = { code: "", description: "" };
      selectChoices.tipoProdotto = { code: "", description: "" };
      selectChoices.garanzie = [];
      selectChoices.tipoPrestazione = [];
      selectChoices.tipoCapitale = { code: "", description: "" };
      selectChoices.tipoRendita = { code: "", description: "" };
      selectChoices.garanzieCompl = [];
      selectChoices.tipoPremio = { code: "", description: "" };
      selectChoices.frazPremio = [];
      selectChoices.durataPianoPagamenti = { code: "", description: "" };
      selectChoices.applSpeseEmissione = { code: "", description: "" };
      selectChoices.applCaricamentoPremio = { code: "", description: "" };
      selectChoices.applCaricamentoCapitale = { code: "", description: "" };
      selectChoices.applCaricamentoEuro = { code: "", description: "" };
      selectChoices.costoVisitaMedica = { code: "", description: "" };
      selectChoices.presenzaCashback = { code: "", description: "" };
      selectChoices.tipoRetrDistr = { code: "", description: "" };
    },
    setPropertiesDefaultCode() {
      if (properties.tariffeProperty.code === "") { properties.tariffeProperty.code = "2a"; }
      if (properties.compagniaProperty.code === "") { properties.compagniaProperty.code = "3"; }
      if (properties.prodCommercioProperty.code === "") { properties.prodCommercioProperty.code = "7"; }
      if (properties.tipoAssicurazioneProperty.code === "") { properties.tipoAssicurazioneProperty.code = "11"; }
      if (properties.tipoProdottoProperty.code === "") { properties.tipoProdottoProperty.code = "13"; }
      if (properties.tipoCapitaleProperty.code === "") { properties.tipoCapitaleProperty.code = "16"; }
      if (properties.tipoRenditaProperty.code === "") { properties.tipoRenditaProperty.code = "18"; }
      if (properties.tipoPremioProperty.code === "") { properties.tipoPremioProperty.code = "22"; }
      if (properties.durataPianoPagamentiProperty.code === "") { properties.durataPianoPagamentiProperty.code = "27"; }
      if (properties.applSpeseEmissioneProperty.code === "") { properties.applSpeseEmissioneProperty.code = "58"; }
      if (properties.applCaricamentoPremioProperty.code === "") { properties.applCaricamentoPremioProperty.code = "60"; }
      if (properties.applCaricamentoCapitaleProperty.code === "") { properties.applCaricamentoCapitaleProperty.code = "62"; }
      if (properties.applCaricamentoEuroProperty.code === "") { properties.applCaricamentoEuroProperty.code = "64"; }
      if (properties.costoVisitaMedicaProperty.code === "") { properties.costoVisitaMedicaProperty.code = "68"; }
      if (properties.presenzaCashbackProperty.code === "") { properties.presenzaCashbackProperty.code = "70"; }
      if (properties.tipoRetrDistrProperty.code === "") { properties.tipoRetrDistrProperty.code = "72"; }
    },
    prefillCodeValue: function(property: any, propCode: string, propValue: string, choices: any, options: any []) {
      property.code = propCode;
      property.value = propValue;
      if (propCode.match(/\./)) {
        const v = options.find((o: any) => o.code === propCode);
        choices = { code: propCode, description: v ? v.description : propValue };
      } else {
        choices = { code: '', description: '' };
      }

      return choices;
    },
    prefillValues: function(property: any, values: any [], choices: any, options: any []) {
      property.values = values;
      if (values.length > 0) {
        choices = [];
        for (let i = 0; i < values.length; i++) {
          const v = options.find((o: any) => o.code === values[i].code);
          choices.push({ code: v.code, description: v.description});
        }
      } else {
        choices = [];
      }

      return choices;
    },
    prefillProperties: async function() {
      const vm = this as any;
      
      // se si arriva da Database.vue bisogna prefillare i campi
      if (vm.productIdSelected != undefined) {
        vm.startLoading();

        const serviceCallReturnValue = await requestService
          .getProduct(vm.productIdSelected)
          .then(handleResponse)
          .then((result: any) => {
            const prodotto = result.properties[0].value;
            const tariffeCode = result.properties[1].code;
            const tariffeValue = result.properties[1].value;
            const codProdCollegato = result.properties[2].value;
            const compagniaCode = result.properties[3].code;
            const compagniaValue = result.properties[3].value;
            const mercatoValue = result.properties[4].value;
            const mercatoValues = result.properties[4].values;
            const canaleValue = result.properties[5].value;
            const canaleValues = result.properties[5].values;
            const distributoriStringList = result.properties[6].stringList;
            const prodCommercioCode = result.properties[7].code;
            const prodCommercioValue = result.properties[7].value;
            const inizioComm = result.properties[8].value;
            const fineComm = result.properties[9].value;
            const edizioneDIPAgg = result.properties[10].value;
            const tipoAssicurazioneCode = result.properties[11].code;
            const tipoAssicurazioneValue = result.properties[11].value;
            const descProdotto = result.properties[12].value;
            const tipoProdottoCode = result.properties[13].code;
            const tipoProdottoValue = result.properties[13].value;
            const garanzieValue = result.properties[14].value;
            const garanzieValues = result.properties[14].values;
            const tipoPrestazioneValue = result.properties[15].value;
            const tipoPrestazioneValues = result.properties[15].values;
            const tipoCapitaleCode = result.properties[16].code;
            const tipoCapitaleValue = result.properties[16].value;
            const capitaleAssicurabile = result.properties[17].value;
            const tipoRenditaCode = result.properties[18].code;
            const tipoRenditaValue = result.properties[18].value;
            const renditaAssicurabile = result.properties[19].value;
            const garanzieComplValue = result.properties[20].value;
            const garanzieComplValues = result.properties[20].values;
            const tipoPremioCode = result.properties[21].code;
            const tipoPremioValue = result.properties[21].value;
            const premioMinimo = result.properties[22].value;
            let premioMinimoSign = result.properties[22].valueSign;
            const frazPremioValue = result.properties[23].value;
            const frazPremioValues = result.properties[23].values;
            const durataContratto = result.properties[24].value;
            const durataPianoPagamentiCode = result.properties[25].code;
            const durataPianoPagamentiValue = result.properties[25].value;
            const etaMaxSottoscrizione = result.properties[26].value;
            let etaMaxSottoscrizioneSign = result.properties[26].valueSign;
            const etaMaxScadenza = result.properties[27].value;
            let etaMaxScadenzaSign = result.properties[27].valueSign;
            const visitaMedica = result.properties[28].value;
            const carenza = result.properties[29].value;
            const targetMarket = result.properties[30].value;
            const decessoQualsiasi = result.properties[31].value;
            const decessoInfortunio = result.properties[32].value;
            const decessoIncidente = result.properties[33].value;
            const decessoMalattia = result.properties[34].value;
            const decessoNucleo = result.properties[35].value;
            const nonAutosufficienza = result.properties[36].value;
            const malattie = result.properties[37].value;
            const invIna = result.properties[38].value;
            const terminal = result.properties[39].value;
            const altreGaranzie = result.properties[40].value;
            const altreOpzioni = result.properties[41].value;
            const sospensionePremi = result.properties[42].value;
            const riattivazionePremi = result.properties[43].value;
            const riduzionePrest = result.properties[44].value;
            const applSpeseEmissioneCode = result.properties[45].code;
            const applSpeseEmissioneValue = result.properties[45].value;
            const speseEmissione = result.properties[46].value;
            const speseEmissioneStringList = result.properties[46].stringList;
            const applCaricamentoPremioCode = result.properties[47].code;
            const applCaricamentoPremioValue = result.properties[47].value;
            const caricamentoPremio = result.properties[48].value;
            const caricamentoPremioStringList = result.properties[48].stringList;
            const applCaricamentoCapitaleCode = result.properties[49].code;
            const applCaricamentoCapitaleValue = result.properties[49].value;
            const caricamentoCapitale = result.properties[50].value;
            const caricamentoCapitaleStringList = result.properties[50].stringList;
            const applCaricamentoEuroCode = result.properties[51].code;
            const applCaricamentoEuroValue = result.properties[51].value;
            const caricamentoEuro = result.properties[52].value;
            const caricamentoEuroStringList = result.properties[52].stringList;
            const interessiFrazValue = result.properties[53].value;
            const interessiFrazFrazionamento = result.properties[53].frazionamento;
            const costoVisitaMedicaCode = result.properties[54].code;
            const costoVisitaMedicaValue = result.properties[54].value;
            const altriCosti = result.properties[55].value;
            const presenzaCashbackCode = result.properties[56].code;
            const presenzaCashbackValue = result.properties[56].value;
            const cashback = result.properties[57].value;
            const cashbackStringList = result.properties[57].stringList;
            const tipoRetrDistrCode = result.properties[58].code;
            const tipoRetrDistrValue = result.properties[58].value;
            const retrDistr = result.properties[59].value;
            const retrDistrStringList = result.properties[59].stringList;
            const note = result.properties[60].value;

            properties.prodottoProperty.value = prodotto;
            selectChoices.tariffe = vm.prefillCodeValue(properties.tariffeProperty, tariffeCode, tariffeValue, selectChoices.tariffe, vm.tariffeOptions);
            properties.codProdCollegatoProperty.value = codProdCollegato;
            selectChoices.compagnia = vm.prefillCodeValue(properties.compagniaProperty, compagniaCode, compagniaValue, selectChoices.compagnia, vm.compagniaOptions);
            properties.mercatoProperty.value = mercatoValue;
            selectChoices.mercato = vm.prefillValues(properties.mercatoProperty, mercatoValues, selectChoices.mercato, vm.mercatoOptions);
            properties.canaleProperty.value = canaleValue;
            selectChoices.canale = vm.prefillValues(properties.canaleProperty, canaleValues, selectChoices.canale, vm.canaleOptions);
            properties.distributoriProperty.stringList = distributoriStringList;
            selectChoices.prodCommercio = vm.prefillCodeValue(properties.prodCommercioProperty, prodCommercioCode, prodCommercioValue, selectChoices.prodCommercio, vm.prodCommercioOptions);
            properties.inizioCommProperty.value = inizioComm;
            properties.inizioCommProperty.dateValue = vm.dateFromString(inizioComm);
            properties.fineCommProperty.value = fineComm;
            properties.fineCommProperty.dateValue = vm.dateFromString(fineComm);
            properties.edizioneDIPAggProperty.value = edizioneDIPAgg;
            properties.edizioneDIPAggProperty.dateValue = vm.dateFromString(edizioneDIPAgg);
            selectChoices.tipoAssicurazione = vm.prefillCodeValue(properties.tipoAssicurazioneProperty, tipoAssicurazioneCode, tipoAssicurazioneValue, selectChoices.tipoAssicurazione, vm.tipoAssicurazioneOptions);
            properties.descProdottoProperty.value = descProdotto;
            selectChoices.tipoProdotto = vm.prefillCodeValue(properties.tipoProdottoProperty, tipoProdottoCode, tipoProdottoValue, selectChoices.tipoProdotto, vm.tipoProdottoOptions);
            properties.garanzieProperty.value = garanzieValue;
            selectChoices.garanzie = vm.prefillValues(properties.garanzieProperty, garanzieValues, selectChoices.garanzie, vm.garanzieOptions);
            properties.tipoPrestazioneProperty.value = tipoPrestazioneValue;
            selectChoices.tipoPrestazione = vm.prefillValues(properties.tipoPrestazioneProperty, tipoPrestazioneValues, selectChoices.tipoPrestazione, vm.tipoPrestazioneOptions);
            selectChoices.tipoCapitale = vm.prefillCodeValue(properties.tipoCapitaleProperty, tipoCapitaleCode, tipoCapitaleValue, selectChoices.tipoCapitale, vm.tipoCapitaleOptions);
            properties.capitaleAssicurabileProperty.value = capitaleAssicurabile;
            selectChoices.tipoRendita = vm.prefillCodeValue(properties.tipoRenditaProperty, tipoRenditaCode, tipoRenditaValue, selectChoices.tipoRendita, vm.tipoRenditaOptions);
            properties.renditaAssicurabileProperty.value = renditaAssicurabile;
            properties.garanzieComplProperty.value = garanzieComplValue;
            selectChoices.garanzieCompl = vm.prefillValues(properties.garanzieComplProperty, garanzieComplValues, selectChoices.garanzieCompl, vm.garanzieComplOptions);
            selectChoices.tipoPremio = vm.prefillCodeValue(properties.tipoPremioProperty, tipoPremioCode, tipoPremioValue, selectChoices.tipoPremio, vm.tipoPremioOptions);

            if (premioMinimoSign === undefined || premioMinimoSign === null) {
              premioMinimoSign = "%";
            }
            properties.premioMinimoProperty.value = premioMinimo;
            properties.premioMinimoProperty.valueSign = premioMinimoSign;
            vm.premioMinimoField.value = premioMinimo;
            vm.premioMinimoField.valueSign = premioMinimoSign;

            properties.frazPremioProperty.value = frazPremioValue;
            selectChoices.frazPremio = vm.prefillValues(properties.frazPremioProperty, frazPremioValues, selectChoices.frazPremio, vm.frazPremioOptions);
            properties.durataContrattoProperty.value = durataContratto;
            selectChoices.durataPianoPagamenti = vm.prefillCodeValue(properties.durataPianoPagamentiProperty, durataPianoPagamentiCode, durataPianoPagamentiValue, selectChoices.durataPianoPagamenti, vm.durataPianoPagamentiOptions);

            if (etaMaxSottoscrizioneSign === undefined || etaMaxSottoscrizioneSign === null) {
              etaMaxSottoscrizioneSign = "anni";
            }
            properties.etaMaxSottoscrizioneProperty.value = etaMaxSottoscrizione;
            properties.etaMaxSottoscrizioneProperty.valueSign = etaMaxSottoscrizioneSign;
            vm.etaMaxSottoscrizioneField.value = etaMaxSottoscrizione;
            vm.etaMaxSottoscrizioneField.valueSign = etaMaxSottoscrizioneSign;

            if (etaMaxScadenzaSign === undefined || etaMaxScadenzaSign === null) {
              etaMaxScadenzaSign = "anni";
            }
            properties.etaMaxScadenzaProperty.value = etaMaxScadenza;
            properties.etaMaxScadenzaProperty.valueSign = etaMaxScadenzaSign;
            vm.etaMaxScadenzaField.value = etaMaxScadenza;
            vm.etaMaxScadenzaField.valueSign = etaMaxScadenzaSign;
            
            properties.visitaMedicaProperty.value = visitaMedica;
            properties.carenzaProperty.value = carenza;
            properties.targetMarketProperty.value = targetMarket;
            properties.decessoQualsiasiProperty.value = decessoQualsiasi;
            properties.decessoInfortunioProperty.value = decessoInfortunio;
            properties.decessoIncidenteProperty.value = decessoIncidente;
            properties.decessoMalattiaProperty.value = decessoMalattia;
            properties.decessoNucleoProperty.value = decessoNucleo;
            properties.nonAutosufficienzaProperty.value = nonAutosufficienza;
            properties.malattieProperty.value = malattie;
            properties.invInaProperty.value = invIna;
            properties.terminalProperty.value = terminal;
            properties.altreGaranzieProperty.value = altreGaranzie;
            properties.altreOpzioniProperty.value = altreOpzioni;
            properties.sospensionePremiProperty.value = sospensionePremi;
            properties.riattivazionePremiProperty.value = riattivazionePremi;
            properties.riduzionePrestProperty.value = riduzionePrest;
            selectChoices.applSpeseEmissione = vm.prefillCodeValue(properties.applSpeseEmissioneProperty, applSpeseEmissioneCode, applSpeseEmissioneValue, selectChoices.applSpeseEmissione, vm.applSpeseEmissioneOptions);
            properties.speseEmissioneProperty.value = speseEmissione;
            properties.speseEmissioneProperty.stringList = speseEmissioneStringList;
            selectChoices.applCaricamentoPremio = vm.prefillCodeValue(properties.applCaricamentoPremioProperty, applCaricamentoPremioCode, applCaricamentoPremioValue, selectChoices.applCaricamentoPremio, vm.applCaricamentoPremioOptions);
            properties.caricamentoPremioProperty.value = caricamentoPremio;
            properties.caricamentoPremioProperty.stringList = caricamentoPremioStringList;
            selectChoices.applCaricamentoCapitale = vm.prefillCodeValue(properties.applCaricamentoCapitaleProperty, applCaricamentoCapitaleCode, applCaricamentoCapitaleValue, selectChoices.applCaricamentoCapitale, vm.applCaricamentoCapitaleOptions);
            properties.caricamentoCapitaleProperty.value = caricamentoCapitale;
            properties.caricamentoCapitaleProperty.stringList = caricamentoCapitaleStringList;
            selectChoices.applCaricamentoEuro = vm.prefillCodeValue(properties.applCaricamentoEuroProperty, applCaricamentoEuroCode, applCaricamentoEuroValue, selectChoices.applCaricamentoEuro, vm.applCaricamentoEuroOptions);
            properties.caricamentoEuroProperty.value = caricamentoEuro;
            properties.caricamentoEuroProperty.stringList = caricamentoEuroStringList;
            properties.interessiFrazProperty.value = interessiFrazValue;
            properties.interessiFrazProperty.frazionamento = interessiFrazFrazionamento;
            selectChoices.costoVisitaMedica = vm.prefillCodeValue(properties.costoVisitaMedicaProperty, costoVisitaMedicaCode, costoVisitaMedicaValue, selectChoices.costoVisitaMedica, vm.costoVisitaMedicaOptions);
            properties.altriCostiProperty.value = altriCosti;
            selectChoices.presenzaCashback = vm.prefillCodeValue(properties.presenzaCashbackProperty, presenzaCashbackCode, presenzaCashbackValue, selectChoices.presenzaCashback, vm.presenzaCashbackOptions);
            properties.cashbackProperty.value = cashback;
            properties.cashbackProperty.stringList = cashbackStringList;
            selectChoices.tipoRetrDistr = vm.prefillCodeValue(properties.tipoRetrDistrProperty, tipoRetrDistrCode, tipoRetrDistrValue, selectChoices.tipoRetrDistr, vm.tipoRetrDistrOptions);
            properties.retrDistrProperty.value = retrDistr;
            properties.retrDistrProperty.stringList = retrDistrStringList;
            
            properties.noteProperty.value = note;
          })
          .catch(() => {
            vm.openModalError();
          })

        vm.stopLoading();
      } else {
        vm.changeTariffe();
        vm.changeFineComm();
        vm.changeTipoPrestazione();
        vm.changeTipoPremio();
        vm.changeGaranzie();
        vm.changeGeneric();
      }

      vm.stopLoading();
    },
    setDatePropertiesValue() {
      const vm = this as any;

      properties.inizioCommProperty.value = vm.formatDate(properties.inizioCommProperty.dateValue);
      if (properties.prodCommercioProperty.code == "7.2") {
        properties.fineCommProperty.value = vm.formatDate(properties.fineCommProperty.dateValue);
      }
      properties.edizioneDIPAggProperty.value = vm.formatDate(properties.edizioneDIPAggProperty.dateValue);
    },
    setAltroDescription: function(property: any, options: any, altroCode: string, altroSpecificValue: string) {
      const vm = this as any;

      let cleanValue = "";
      for (let i = 0; i < options.length; i++) {
        if (options[i].code == altroCode) {
          cleanValue = options[i].description;
        }
      }
      for (let i = 0; i < property.values.length; i++) {
        if (property.values[i].code == altroCode) {
          property.values[i].description = cleanValue + " " + altroSpecificValue;
        }
      }
    },
    getAltroDescription: function(property: any, optionCode: string, options: any) {
      let optionDescription = "";
      for (let i = 0; i < options.length; i++) {
        if (options[i].code == optionCode) {
          optionDescription = options[i].description + " ";
        }
      }
      for (let i = 0; i < property.values.length; i++) {
        const propIValue = property.values[i] as any;
        if (propIValue.code == optionCode) {
          return propIValue.description.substring(optionDescription.length);
        }
      }
      return undefined;
    },
    preparePropList() {
      const vm = this as any;

      Vue.set(properties.speseEmissioneProperty, 'nodashed', true);
      Vue.set(properties.caricamentoPremioProperty, 'nodashed', true);
      Vue.set(properties.caricamentoCapitaleProperty, 'nodashed', true);
      Vue.set(properties.caricamentoEuroProperty, 'nodashed', true);
      Vue.set(properties.cashbackProperty, 'nodashed', true);
      Vue.set(properties.retrDistrProperty, 'nodashed', true);

      vm.setDatePropertiesValue();

      properties.premioMinimoProperty.value = vm.premioMinimoField.value;
      properties.premioMinimoProperty.valueSign = vm.premioMinimoField.valueSign;
      properties.etaMaxSottoscrizioneProperty.value = vm.etaMaxSottoscrizioneField.value;
      properties.etaMaxSottoscrizioneProperty.valueSign = vm.etaMaxSottoscrizioneField.valueSign;
      properties.etaMaxScadenzaProperty.value = vm.etaMaxScadenzaField.value;
      properties.etaMaxScadenzaProperty.valueSign = vm.etaMaxScadenzaField.valueSign;

      vm.propList = [
        properties.prodottoProperty,
        properties.tariffeProperty,
        properties.codProdCollegatoProperty,
        properties.compagniaProperty,
        properties.mercatoProperty,
        properties.canaleProperty,
        properties.distributoriProperty,
        properties.prodCommercioProperty,
        properties.inizioCommProperty,
        properties.fineCommProperty,
        properties.edizioneDIPAggProperty,
        properties.tipoAssicurazioneProperty,
        properties.descProdottoProperty,
        properties.tipoProdottoProperty,
        properties.garanzieProperty,
        properties.tipoPrestazioneProperty,
        properties.tipoCapitaleProperty,
        properties.capitaleAssicurabileProperty,
        properties.tipoRenditaProperty,
        properties.renditaAssicurabileProperty,
        properties.garanzieComplProperty,
        properties.tipoPremioProperty,
        properties.premioMinimoProperty,
        properties.frazPremioProperty,
        properties.durataContrattoProperty,
        properties.durataPianoPagamentiProperty,
        properties.etaMaxSottoscrizioneProperty,
        properties.etaMaxScadenzaProperty,
        properties.visitaMedicaProperty,
        properties.carenzaProperty,
        properties.targetMarketProperty,
        properties.decessoQualsiasiProperty,
        properties.decessoInfortunioProperty,
        properties.decessoIncidenteProperty,
        properties.decessoMalattiaProperty,
        properties.decessoNucleoProperty,
        properties.nonAutosufficienzaProperty,
        properties.malattieProperty,
        properties.invInaProperty,
        properties.terminalProperty,
        properties.altreGaranzieProperty,
        properties.altreOpzioniProperty,
        properties.sospensionePremiProperty,
        properties.riattivazionePremiProperty,
        properties.riduzionePrestProperty,
        properties.applSpeseEmissioneProperty,
        properties.speseEmissioneProperty,
        properties.applCaricamentoPremioProperty,
        properties.caricamentoPremioProperty,
        properties.applCaricamentoCapitaleProperty,
        properties.caricamentoCapitaleProperty,
        properties.applCaricamentoEuroProperty,
        properties.caricamentoEuroProperty,
        properties.interessiFrazProperty,
        properties.costoVisitaMedicaProperty,
        properties.altriCostiProperty,
        properties.presenzaCashbackProperty,
        properties.cashbackProperty,
        properties.tipoRetrDistrProperty,
        properties.retrDistrProperty,
        properties.noteProperty,
      ];
    },
    formatDateF: function(data: Date | string, formatStr: string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, formatStr);
    },
    printStringListItem(item: any) {
      let retValue = undefined;
      if (item.valueSign == "€") {
        retValue = (item.valueLabel !== undefined && item.valueLabel !== null && item.valueLabel !== "" ? item.valueLabel + " " : "") + item.valueSign + " " + item.value;
      } else {
        retValue = (item.valueLabel !== undefined && item.valueLabel !== null && item.valueLabel !== "" ? item.valueLabel + " " : "") + item.value + item.valueSign;
      }

      return retValue;
    },
    selectedFile: function(fileList: any[]) {
      if (!fileList.length) return;
      this.massiveFile = fileList[0];
    },
    uploadMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.uploadMassive(categories.VITA_PROTEZIONE, vm.massiveFile)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          if (result !== undefined) {
            vm.massiveLoaded = true;
            vm.massiveResult = result;
          } else {
            vm.closeModalMassivo();
            vm.openModalError("Non è stato possibile caricare il file.");
          }
        })
        .catch(() => {
          vm.stopLoading();
          vm.openModalError("Non è stato possibile caricare il file.");
        });
    },
    confirmMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.confirmMassive(vm.massiveResult.massiveId)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.closeModalMassivo();
          vm.openModalError("Prodotti caricati.", "OK"); // non è un errore, sfrutto per aprire la modale
        })
        .catch(() => {
          vm.stopLoading();
          vm.openModalError("Non è stato possibile confermare i dati caricati.");
        });
    },
    deleteMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.deleteMassive(vm.massiveResult.massiveId)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.closeModalMassivo();
          vm.openModalError("Caricamento massivo annullato.", "OK"); // non è un errore, sfrutto per aprire la modale
        })
        .catch(() => {
          vm.stopLoading();
          vm.closeModalMassivo();
        });
    },
    printVersatileValues(property: any) {
      const vm = this as any;

      const noDashed = (property.nodashed === undefined || property.nodashed === null) ? false : property.nodashed;

      let isPrintStringList = false;
      if (property.type == propertyTypes.STRING_LIST) {
        isPrintStringList = true;
      } else if (property.stringList !== undefined && property.stringList !== null) {
        if (property.stringList.length > 0) {
          isPrintStringList = true;
        }
      }

      let printableValue = "";
      let tooltipValue = "";
      if (property.type == propertyTypes.VALUES) {
        if (property.values.length > 0) {
          //property.values.sort(this._compare);
          if (property.values.length == 1) {
            const item = property.values[0];
            printableValue = item.description;
          } else {
            const maxLi = 3;
            let liCounter = 0;
            let li = "";
            // printableValue & tooltipValue
            const tooltipLi = property.values.map(function(item: any) {
              //li is a subset of what in tooltipLi (all)
              liCounter++;
              if (liCounter < maxLi) {
                li += "<li>" + item.description + "</li>";
              } else if (liCounter == maxLi) {
                li += "<li>" + '...' + "</li>";
              }
              return "<li>" + item.description + "</li>";
            }).join("");

            printableValue = "<div><ul class='dashed'>" + li + "</ul><div>";
            if (liCounter >= maxLi) {
              tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul><div>";
            }
          }
        } else {
          printableValue = property.value;
        }
      } else if (isPrintStringList) {
        if (property.value !== "") {
          printableValue = property.value;
        } else if (property.stringList.length == 1) {
          const item = property.stringList[0];
          printableValue = vm.printStringListItem(item);
        } else if (noDashed === undefined || !noDashed) {
          const maxLi = 3;
          let liCounter = 0;
          let li = "";
          // printableValue & tooltipValue
          const tooltipLi = property.stringList.map(function(item: any) {
            //li is a subset of what in tooltipLi (all)
            liCounter++;
            if (liCounter < maxLi) {
              li += "<li>" + item.value + item.valueSign + "</li>";
            } else if (liCounter == maxLi) {
              li += "<li>" + '...' + "</li>";
            }
            return "<li>" + item.value + item.valueSign + "</li>";
          }).join("");

          printableValue = "<div><ul class='dashed'>" + li + "</ul><div>";
          if (liCounter >= maxLi) {
            tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul><div>";
          }
        } else if (noDashed) {
          let equalValues = (property.stringList.length == 2 && property.stringList[0].value == property.stringList[1].value && property.stringList[0].valueSign == property.stringList[1].valueSign);
          if (equalValues) {
            if (property.stringList[0].valueSign == "€") {
              printableValue = property.stringList[0].valueSign + " " + property.stringList[0].value;
            } else {
              printableValue = property.stringList[0].value + property.stringList[0].valueSign;
            }
          } else {
            const li = property.stringList.map(function(item: any) {
              return "<li>" + vm.printStringListItem(item) + "</li>";
            }).join("");
            printableValue = "<ul class='nodashed'>" + li + "</ul>";
          }
        }
      } else if (property.type == propertyTypes.FRAZIONAMENTO) {
        if (property.value === vm.ND) {
          printableValue = property.value;
        } else {
          let values = [];
          if (property.frazionamento.mensile !== vm.ND) {
            values.push("Mensile: " + property.frazionamento.mensile + property.frazionamento.mensileSign);
          }
          if (property.frazionamento.bimestrale !== vm.ND) {
            values.push("Bimestrale: " + property.frazionamento.bimestrale + property.frazionamento.bimestraleSign);
          }
          if (property.frazionamento.trimestrale !== vm.ND) {
            values.push("Trimestrale: " + property.frazionamento.trimestrale + property.frazionamento.trimestraleSign);
          }
          if (property.frazionamento.quadrimestrale !== vm.ND) {
            values.push("Quadrimestrale: " + property.frazionamento.quadrimestrale + property.frazionamento.quadrimestraleSign);
          }
          if (property.frazionamento.semestrale !== vm.ND) {
            values.push("Semestrale: " + property.frazionamento.semestrale + property.frazionamento.semestraleSign);
          }
          if (values.length == 1) {
            printableValue = values[0];
          } else if (values.length > 1) {
            const maxLi = 3;
            let liCounter = 0;
            let li = "";
            const tooltipLi = values.map(function(s: any) {
              liCounter++;
              if (liCounter < maxLi) {
                li += "<li>" + s + "</li>";
              } else if (liCounter == maxLi) {
                li += "<li>" + '...' + "</li>";
              }
              return "<li>" + s + "</li>";
            }).join("");
            printableValue = "<ul class='dashed'>" + li + "</ul>"
            if (liCounter >= maxLi) {
              tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul><div>";
            }
          }
        }
      } else if (property.type == propertyTypes.DATE) {
        const d = vm.dateFromString(property.value);
        if (d != null) {
          printableValue = vm.formatDateF(d, "MM/yyyy");
        } else {
          printableValue = property.value;
        }
      } else {
        const maxCharsPerRow = 40;
        const maxRows = 1;
        let printedRows = 0;
        let flagDots = false;
        if (property.value !== undefined && property.value !== null) {
          if (property.value.length > maxCharsPerRow) {

            for (let i = 0; i < property.value.length && printedRows < maxRows;) {
              let endIndex = Math.min(i+maxCharsPerRow, property.value.length);
              let dots = "";
              if (printedRows+1 == maxRows) {
                dots = "...";
                flagDots = true;
              }
              printableValue += "<div>" + property.value.substring(i, endIndex) + dots + "</div>";
              i += maxCharsPerRow;
              printedRows += 1;
            }

            if (flagDots) {
              tooltipValue = property.value;
            }
          } else {
            printableValue = property.value;
          }
        }
      }

      if (tooltipValue !== undefined && !vm.isEmptyOrSpaces(tooltipValue)) {
        printableValue = tooltipValue;
      }

      printableValue = printableValue.replace(/\n/g, "<br />");

      return printableValue;
    },
    inserisciProdotto: async function() {
      const vm = this as any;
      vm.startLoading();
      let productId = undefined;

      if (vm.productIdSelected === undefined) {
        let nuovoProdotto = {} as any;
        nuovoProdotto = await vm.registraProdotto();
        if (nuovoProdotto == undefined) {
          vm.stopLoading();
          vm.openModalError();
        } else {
          productId = nuovoProdotto.productId;
        }
      } else {
        productId = vm.productIdSelected;
      }

      if (productId === undefined) {
        vm.stopLoading();
        vm.openModalError();
      } else {
        //FINE FUNZIONI DI MAPPING
        vm.valorizzaTendine();

        vm.setDatePropertiesValue();

        vm.setPropertiesDefaultCode();

        vm.preparePropList();

        const serviceCallReturnValue = await requestService
          .addProductPropertyList({
            productId: productId,
            propertyList: vm.propList
          })
          .then(handleResponse)
          .then((result: any) => {
            if (!isNil(result.productId)) {
              vm.esitoRegistrazione = "Registrazione avvenuta con successo";
            } else {
              vm.esitoRegistrazione = "Registrazione KO";
            }

            return result.productId;
          })
          .catch(() => {
            vm.openModalError();
          });

        vm.stopLoading();

        vm.closeModalConfirm();

        vm.openModalConfirmOutcome();
      }
    },
    registraProdotto: async function() {
      return requestService.initProductWithCategory(categories.VITA_PROTEZIONE).then(handleResponse);
    },
    _compareDesc: function(a: any, b: any) {
      const aDesc = a.description;
      const bDesc = b.description;
      if (aDesc === undefined || bDesc === undefined) {
        if (bDesc !== undefined) {
          return -1;
        }
        if (aDesc !== undefined) {
          return 1;
        }
        return 0;
      }

      if (aDesc > bDesc) {
        return 1;
      } else {
        return -1;
      }
    },
    isAdmin: function() {
      const vm = this as any;
      const isAdmin = vm.loggedUser.roles.indexOf('admin') >= 0;
      const isAdminView = vm.loggedUser.roles.indexOf('admin-view') >= 0;
      return isAdmin || isAdminView;
    },
    massivo: function() {
      const vm = this as any;
      const isAdmin = vm.loggedUser.roles.indexOf('admin') >= 0;
      const isMassivo = vm.loggedUser.roles.indexOf('massivo') >= 0;

      return isAdmin || isMassivo;
    },
  },
  created() {
    const vm = this as any;

    // sort compagnie by desc
    vm.compagniaOptions.sort(vm._compareDesc);

    vm.cleanAllProperties();

    vm.prefillProperties();
  },
  mounted() {
    const vm = this as any;
    if (!vm.loggedUser) {
      vm.home();
    } else {
      const hasRole = vm.loggedUser.roles.indexOf('vita-protezione') >= 0;

      if (!vm.isAdmin() && !hasRole) {
        vm.home();
      }
    }
  },
  destroyed() {
    const vm = this as any;
    //vm.stopLoading();
    vm.closeModalError();
  },  
});
